import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';

const WsContext = createContext(null);

export function WsProvider({ children }) {
  const wsRef = useRef(null);
  const retryRef = useRef(0);

  const [isConnected, setIsConnected] = useState(false);
  const [lastEvent, setLastEvent] = useState(null);
  const [events, setEvents] = useState([]); // optional: simpan list event utk notif

  const WS_URL = useMemo(() => {
    const host = window.location.hostname;
    return `ws://${host}:3000/ws/messages`;
  }, []);

  const connect = () => {
    if (wsRef.current && (wsRef.current.readyState === 0 || wsRef.current.readyState === 1)) return;

    const ws = new WebSocket(WS_URL);
    wsRef.current = ws;

    ws.onopen = () => {
      retryRef.current = 0;
      setIsConnected(true);
      // console.log('[WS] connected', WS_URL);
    };

    ws.onmessage = (evt) => {
      try {
        const raw = JSON.parse(evt.data);
        if (raw?.type === 'connected') return;

        setLastEvent(raw);

        setEvents((prev) => {
          const next = [raw, ...(Array.isArray(prev) ? prev : [])];
          if (next.length > 50) next.length = 50;
          return next;
        });
      } catch (e) {
        // ignore parse errors
      }
    };

    ws.onclose = () => {
      setIsConnected(false);

      const retry = retryRef.current + 1;
      retryRef.current = retry;
      const delay = Math.min(1000 * Math.pow(2, Math.min(retry, 5)), 15000);

      setTimeout(() => {
        connect();
      }, delay);
    };

    ws.onerror = () => {
      // onclose akan handle retry
    };
  };

  useEffect(() => {
    connect();
    return () => {
      try {
        wsRef.current?.close();
      } catch {}
      wsRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [WS_URL]);

  const value = useMemo(
    () => ({
      ws: wsRef,
      isConnected,
      lastEvent,
      events,
      clearEvents: () => setEvents([])
    }),
    [isConnected, lastEvent, events]
  );

  return <WsContext.Provider value={value}>{children}</WsContext.Provider>;
}

export function useWs() {
  const ctx = useContext(WsContext);
  if (!ctx) throw new Error('useWs must be used inside <WsProvider />');
  return ctx;
}
